import { useSelector } from 'react-redux'

const NN_ORGANIZATION_IDS = ['6a554d0cc566779d4b2eccfe', '6a567b7e7aaede43b427fc2c']

export const useIsNNOrganization = () => {
    // @ts-expect-error redux store's state is not properly typed
    const userRecordOrganizationId = useSelector((state) => state?.userRecord?.organizationId)
    // @ts-expect-error redux store's state is not properly typed
    const strategyOrganizationId = useSelector((state) => state?.strategy?.organizationId)

    const isNNOrganization =
        NN_ORGANIZATION_IDS.includes(userRecordOrganizationId) || NN_ORGANIZATION_IDS.includes(strategyOrganizationId)

    return isNNOrganization
}
